<div *ngIf="
    (product.estoque > 0 || !validaEstoque) &&
    pedidoService.pedido &&
    pedidoService.pedido.clientes.length === 1
  ">

  <div *ngIf="product.sku; else semSku" class="qty-actions">
    <div class="qty-stepper" role="group" aria-label="Quantidade">
      <button
        type="button"
        class="qty-step noselect {{ inputClass }}"
        (click)="less(product.multiplo)"
        aria-label="Diminuir quantidade"
      >
        −
      </button>
      <input
        [value]="quantity"
        type="number"
        (keyup)="setQuantity($event)"
        (keyup.enter)="addCart()"
        class="qty-field {{ inputClass }}"
        min="0"
        aria-label="Quantidade"
      />
      <button
        type="button"
        class="qty-step noselect {{ inputClass }}"
        (click)="plus(product.multiplo)"
        aria-label="Aumentar quantidade"
      >
        +
      </button>
    </div>
    <button
      type="button"
      class="qty-add"
      (click)="addCart()"
      [style.backgroundColor]="SITE.backgroundColorSliderSuperior"
    >
      <i class="{{ SITE ? SITE.iconCart : '' }}"></i>
      <span class="qty-add-label" i18n>Adicionar</span>
    </button>
  </div>

  <ng-template #semSku>
    <button
      type="button"
      class="qty-add qty-add-full"
      (click)="redirectTo.emit(product.id)"
      [style.backgroundColor]="SITE.backgroundColorSliderSuperior"
    >
      <i class="{{ SITE ? SITE.iconCart : '' }}"></i>
      <span i18n>Comprar</span>
    </button>
  </ng-template>
</div>
